import React, { useState } from "react";
import "../styles/SupportPage.css"
import emailjs from '@emailjs/browser';

const SupportPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // deprecated: using sendEmail instead

 const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_ooob27q', 'template_eprk9q9', e.target, 'fUUgZ4BuPt-h0FxeW')
    .then((result) => {
      console.log(result.text);
      setSubmitted(true);
      setFormData({ name: "", email: "", message: "" }); // Limpiar el formulario
    }, (error) => {
      console.log(error.text);
    });
};

  return (
    <main className="support-container">
      <header>
        <h1>Support & Help Center</h1>
        <p>If you have any questions or issues, feel free to reach out to us.</p>
      </header>

      <section aria-labelledby="faq-heading">
        <h2 id="faq-heading">Frequently Asked Questions</h2>
        <section className="faq-section">
        <details>
          <summary>How does the home page work?</summary>
          <p>The home page displays top-rated, now-playing, and upcoming movies. You can filter the movies that we are showing at the moment by genre, duration, rating, or search for specific titles.</p>
        </details>
        <details>
          <summary>Can I book a seat without logging in?</summary>
          <p>No, you must be logged in to book a seat.</p>
        </details>
        <details>
          <summary>Do I need to bring my reservation number?</summary>
          <p>Yes, you must bring your reservation number when you arrive at the cinema to confirm and pay for your booking.</p>
        </details>
        <details>
          <summary>What payment methods do you accept?</summary>
          <p>We accept credit cards, PayPal, and Apple Pay.</p>
        </details>
        <details>
          <summary>How can I change my account details?</summary>
          <p>You can update your account details by visiting the profile page and editing your information, such as name, email, and password.</p>
        </details>
        <details>
          <summary>Can I browse movies without an account?</summary>
          <p>Yes, you can browse movies and view details without an account, but booking requires logging in.</p>
        </details>
        <details>
          <summary>How do I report an issue with my booking?</summary>
          <p>If you experience any issues with your booking, please contact our support team using the contact form below.</p>
        </details>
        <details>
          <summary>Can I cancel a reservation?</summary>
          <p>Yes, you can cancel a reservation on the bookings page.</p>
        </details>
        </section>
      </section>

      <section aria-labelledby="contact-heading">
        <h3 id="contact-heading">Contact Us</h3>
      {submitted ? (
        <p>Thank you! Your message has been received. We will get back to you soon.</p>
      ) : (
        <form className="support-form" onSubmit={sendEmail} aria-label="Contact form">
          <label htmlFor="contact-name" className="visually-hidden">Your Name</label>
          <input id="contact-name" type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
          <label htmlFor="contact-email" className="visually-hidden">Your Email</label>
          <input id="contact-email" type="email" name="email_from" placeholder="Your Email" required onChange={handleChange} />
          <label htmlFor="contact-message" className="visually-hidden">Your Message</label>
          <textarea id="contact-message" name="message" placeholder="Your Message" required onChange={handleChange}></textarea>
          <button type="submit">Submit</button>
        </form>
      )}

      </section>

      <section id="privacy" className="privacy-section" aria-labelledby="privacy-heading">
        <h3 id="privacy-heading">Privacy Policy</h3>
        <p>We care about protecting your personal data. Below is a short overview of how we process data when you use this app.</p>
        <h4>Controller</h4>
        <p>
          Georg-August-Universität Göttingen<br />
          Institut für Informatik<br />
          Goldschmidtstr. 7, 37077 Göttingen, Germany<br />
          Tel.: +49 (0)551 39-172000<br />
          Imprint: Imprint
        </p>
        <h4>Data Protection Officer</h4>
        <p>Please contact the University's Data Protection Officer:</p>
        <p>
          Prof. Dr. Andreas Wiebe, LL.M. (Virginia)<br />
          Platz der Göttinger Sieben 6, 37073 Göttingen, Germany<br />
          Tel.: +49 (0)551 39-27381
        </p>
        <p><strong>Deputy Data Protection Officer:</strong></p>
        <p>
          Florian Hallaschka<br />
          Goßlerstraße 5/7, 37073 Göttingen, Germany<br />
          Tel.: +49 (0)551 39-24689
        </p>
        <p>
          For general data protection inquiries, please use the University's official contact form: Contact form.
        </p>
        <p>
          For reporting data protection incidents, please use the University's Lucom form: Lucom incident form.
        </p>
        <h4>What data do we process?</h4>
        <ul>
          <li>Account and profile data (e.g., name, email)</li>
          <li>Booking data (e.g., selected showtimes, seats, reservation number)</li>
          <li>In‑app usage data (e.g., interactions, favorites)</li>
          <li>Support requests (your message content, email, name) – sent via our email provider (e.g., EmailJS) acting as a processor</li>
        </ul>
        <h4>Purposes</h4>
        <ul>
          <li>Provide the app, registration, and bookings</li>
          <li>Handle support requests</li>
          <li>Security, abuse prevention, and error analysis</li>
        </ul>
        <h4>Retention</h4>
        <p>We keep personal data only as long as necessary for the stated purposes. Support requests are typically retained for up to 12 months. Legal retention periods may apply.</p>
        <h4>Recipients</h4>
        <p>We use carefully selected service providers for hosting and email as processors. We do not share data with third parties for advertising.</p>
        <h4>International transfers</h4>
        <p>If providers outside the EU/EEA are used, we ensure appropriate safeguards (e.g., EU Standard Contractual Clauses).</p>
        <h4>Cookies and tracking</h4>
        <p>We use only strictly necessary cookies/functions, for example for sign‑in and session management. No advertising profiling takes place.</p>
        <h4>Your rights</h4>
        <ul>
          <li>Access, rectification, erasure, restriction, portability</li>
          <li>Object to processing based on legitimate interests</li>
          <li>Right to lodge a complaint with a supervisory authority</li>
        </ul>
        <h4>Contact</h4>
  <p>For privacy inquiries, please use the support form on this page.</p>
  <p>Last updated: <time dateTime="2025-08-28">Aug 28, 2025</time></p>
      </section>

      <section id="accessibility" className="accessibility-section" aria-labelledby="accessibility-heading">
        <h3 id="accessibility-heading">Accessibility Statement</h3>
        <p>We aim to make this application accessible to everyone. We follow the WCAG 2.1 AA guidelines and continuously work on improvements.</p>
        <h4>Conformance status</h4>
        <p>This application is currently <strong>partially conformant</strong>. Some areas do not yet fully meet the criteria.</p>
        <h4>Measures taken</h4>
        <ul>
          <li>Semantic HTML structure and ARIA attributes</li>
          <li>Keyboard operability of core functions</li>
          <li>Focus management and clear labels</li>
        </ul>
        <h4>Known issues</h4>
        <ul>
          <li>Contrast for some elements can be improved</li>
          <li>Focus visibility is not fully consistent across all components</li>
          <li>Some dynamic content needs additional screen reader cues</li>
        </ul>
        <h4>Feedback and contact</h4>
        <p>If you encounter barriers or have suggestions, please contact us via the support form on this page. We typically respond within a few business days.</p>
        <h4>Compatibility</h4>
        <p>The app is optimized for current versions of major browsers and operating systems. Older or heavily customized environments may have limitations.</p>
  <p>Last updated: <time dateTime="2025-08-28">Aug 28, 2025</time></p>
      </section>
      <footer className="support-footer" aria-label="Legal links">
        <a
          href="https://www.uni-goettingen.de/de/439238.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Impressum
        </a>
      </footer>
    </main>
  );
};

export default SupportPage;
